var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fa fa-money fa-lg icon-button mr-1",attrs:{"title":"Aprovar"},on:{"click":function($event){$event.stopPropagation();return _vm.detalharPagamento()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }